<template>
  <VList :meta="meta">
    <template #before>
      <VListHeader />
    </template>

    <template v-if="isLoading" #default>
      <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
        <Loader />
      </div>
    </template>

    <template v-else-if="isRejected" #default>
      <div class="odd:bg-red-100 border border-red-200 rounded p-4 text-red-600 text-center">
        Something went wrong. Please try again later.
      </div>
    </template>

    <template v-else-if="tasks.length" #default>
      <template v-for="task in tasks">
        <VListLine
          :key="`tasks_${task.uuid}`"
          :task="task"
          :focus="lastEditedTaskId === task.uuid"
          :disabled="isLoading"
          @selected-task="$emit('selected-task', $event)"
        />
      </template>
    </template>

    <template v-else #default>
      <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
        No results found
      </div>
    </template>
  </VList>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import VList from '@/components/Common/VList.vue';
import VListHeader from '@/components/Tasks/VListHeader.vue';
import VListLine from '@/components/Tasks/VListLine.vue';

const STATUS_IDLE = 'idle';
const STATUS_PENDING = 'pending';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

export default {
  name: 'TaskList',

  components: {
    VList,
    VListHeader,
    VListLine,
  },

  props: {
    lastEditedTaskId: {
      type: String,
      default: null,
    },
  },

  data: () => ({
    status: STATUS_IDLE,
  }),

  computed: {
    ...mapState('ui/tasks', ['meta']),
    ...mapGetters('ui/tasks', ['tasks']),
    isLoading() {
      return this.status === STATUS_PENDING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  watch: {
    $route: 'fetchData',
  },

  created() {
    this.fetchData();
  },

  methods: {
    ...mapActions('ui/tasks', {
      loadTasks: 'load',
    }),

    ...mapMutations('ui/tasks', ['setIds', 'setMeta', 'setLinks']),

    async fetchData() {
      const {
        query: { sort = '', filter = {}, ...restQuery },
      } = this.$route;

      const sortParams = sort.split(',');
      sortParams.push('-created_at');

      this.status = STATUS_PENDING;

      try {
        await this.loadTasks({
          params: {
            filter: {
              ...filter,
              has_project: true,
            },
            ...restQuery,
            include: 'account,userAssigned,project.accountRelation,',
            sort: sortParams.join(','),
          },
        });

        this.status = STATUS_RESOLVED;
      } catch (error) {
        this.status = STATUS_REJECTED;
      }
    },
  },
};
</script>
